"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = __importDefault(require("@fullcalendar/react"));
const daygrid_1 = __importDefault(require("@fullcalendar/daygrid"));
const timegrid_1 = __importDefault(require("@fullcalendar/timegrid"));
require("./FoodCalendar.css");
// Get color by category
const categoryToColor = (category) => {
    if (category === "Groceries") {
        return "#b5e670";
    }
    else if (category === "Meal") {
        return "#ffac31";
    }
    else {
        // snack or drink
        return "#819ff1";
    }
};
const convertToCalendarEvent = (foodEvent) => {
    const startTime = foodEvent.scheduledDate;
    const endTime = new Date(startTime);
    endTime.setHours(endTime.getHours() + 1);
    return {
        id: foodEvent._id,
        title: foodEvent.title || `${foodEvent.food_type} in ${foodEvent.location}`,
        url: `${window.location.origin}/food/scheduled/#${foodEvent._id}`,
        start: startTime,
        end: endTime,
        textColor: "#283857",
        color: categoryToColor(foodEvent.food_category),
    };
};
// https://fullcalendar.io/demos
function FoodCalendar(props) {
    const calendarRef = (0, react_1.useRef)(null);
    // Pretty sure we don't need this, but leaving as a refernece juts in case
    /*const handleAddEvent = () => {
      const dateStr = prompt("Enter a date in YYYY-MM-DD format");
      const date = new Date(dateStr + "T00:00:00");
  
      if (!isNaN(date.valueOf())) {
        if (calendarRef.current) {
          calendarRef.current.getApi().addEvent({
            title: "dynamic event",
            start: date,
            allDay: true,
          });
          alert("Great. Now, update your database...");
        }
      } else {
        alert("Invalid date.");
      }
    };*/
    return (react_1.default.createElement(react_2.default, { ref: calendarRef, 
        // TODO: i like height auto but it breaks the header on dark mode
        //   height="auto"
        // height="100vh" // comment out for full squares + scrolling
        //   stickyHeaderDates={true} // auto by default, meaning the calendar has the potential to be very tall, sticky-header-dates will be activated
        plugins: [daygrid_1.default, timegrid_1.default], initialView: "dayGridMonth", timeZone: "EST", headerToolbar: {
            //   left: "prev,next",
            //   center: "title",
            //   right: "dayGridMonth,dayGridWeek", // user can switch between the two
            left: "title",
            // center: "prev,addEventButton,next",
            center: "prev,next",
            // TODO: choosing timeGrid instead of dayGrid because it looks more Googel Calendar - actually shows
            // start and end time - but maybe the other is bette ron mobile
            right: "today dayGridMonth,timeGridWeek,timeGridDay", // user can switch between the two
        }, 
        // https://fullcalendar.io/docs/date-formatting
        //   titleFormat={{ // will produce something like "Tuesday, September 18, 2018"
        //     month: 'long',
        //     year: 'numeric',
        //     day: 'numeric',
        //     weekday: 'long'
        //   }}
        events: props.foodEvents.map(convertToCalendarEvent) }));
}
exports.default = FoodCalendar;
